__turbopack_context__.v({
  "disabled": "ToggleButtons-module-scss-module__QPTPrG__disabled",
  "fullWidth": "ToggleButtons-module-scss-module__QPTPrG__fullWidth",
  "isSelected": "ToggleButtons-module-scss-module__QPTPrG__isSelected",
  "root": "ToggleButtons-module-scss-module__QPTPrG__root",
});
